import Layout from '@/views/Layout';

// 运营管理

export default {
  name: 'OperationManage',
  path: '/operation-manage',
  meta: {
    icon: 'el-icon-setting',
    label: '运营管理',
    isMenu: true,
  },
  component: Layout,
  children: [
    {
      name: 'OperationManageDict',
      path: 'dict',
      meta: {
        label: '字典管理',
        isMenu: true,
      },
      component: { render: (h) => h('router-view') },
      children: [
        {
          name: 'OperationManageDictList',
          path: '',
          meta: {
            label: '字典',
          },
          component: () => import('@/views/OperationManage/Dict/List'),
        },
        {
          name: 'OperationManageDictSubList',
          path: 'sub/:dictId+',
          meta: {
            label: '详细',
          },
          component: () => import('@/views/OperationManage/Dict/SubList'),
        },
      ],
    },
    {
      name: 'OperationManageAdvProd',
      path: 'adv-prod',
      meta: {
        label: '账户管理',
        isMenu: true,
      },
      component: () => import('@/views/OperationManage/AdvProd/AdvProd.vue'),
    },
    {
      name: 'OperationProductManage',
      path: 'operation-product',
      meta: {
        label: '产品管理',
        isMenu: true,
      },
      component: () => import('@/views/OperationManage/Product/Index.vue'),
    },
    {
      name: 'OperationManageCustomer',
      path: 'customer',
      meta: {
        label: '客户管理',
        isMenu: true,
      },
      component: { render: (h) => h('router-view') },
      children: [
        {
          name: 'OperationManageCustomerList',
          path: '',
          meta: {
            label: '客户列表',
          },
          component: () =>
            import('@/views/OperationManage/Customer/CustomerList'),
        },
        {
          name: 'OperationManageCustomerProductList',
          path: 'product',
          meta: {
            label: '产品列表',
          },
          component: () =>
            import('@/views/OperationManage/Customer/ProductList'),
        },
      ],
    },
    {
      name: 'AggregationBudgetBind',
      path: 'aggregation-bind',
      meta: {
        label: '聚合预算管理',
        isMenu: true,
      },
      component: () =>
        import('@/views/OperationManage/AggregationBind/Index.vue'),
    },
    {
      name: 'AggregationBudgetManage',
      path: 'aggregation-budget',
      meta: {
        label: '聚合预算规则',
        isMenu: true,
      },
      component: () =>
        import('@/views/OperationManage/AggregationBudget/Index.vue'),
    },
    {
      name: '产品系管理',
      path: 'product-series',
      meta: {
        label: '产品系管理',
        isMenu: true,
      },
      component: () =>
        import('@/views/OperationManage/ProductSeries/Index.vue'),
    },
    {
      name: 'AggregationBudgetManage',
      path: 'task-tag',
      meta: {
        label: '任务标签管理',
        isMenu: true,
      },
      component: () =>
        import('@/views/OperationManage/TaskTag/Index.vue'),
    },
  ],
};
